var _excluded = ["disabled", "extraProps", "value", "onChange", "minWidth"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { guid } from '@okee-uikit/react-utils';
export var Group = function () {
  function Group(conf) {
    _classCallCheck(this, Group);

    this.group = Group.GROUP_FREE;
    this.disposed = false;
    this.map = {};
    var disabled = conf.disabled,
        extraProps = conf.extraProps,
        value = conf.value,
        onChange = conf.onChange,
        minWidth = conf.minWidth;
    this.extraProps = extraProps;
    this.disabled = disabled;
    this.value = value;
    this.onChange = onChange;
    this.minWidth = minWidth;
  }

  _createClass(Group, [{
    key: "updateGroupOptions",
    value: function updateGroupOptions(conf) {
      var _this = this;

      var disabled = conf.disabled,
          extraProps = conf.extraProps,
          value = conf.value,
          onChange = conf.onChange,
          minWidth = conf.minWidth,
          extra = _objectWithoutProperties(conf, _excluded);

      this.extraProps = extraProps;
      this.disabled = disabled;
      this.value = value;
      this.onChange = onChange;
      this.minWidth = minWidth;
      var group = Group.GROUP_FREE;
      Object.keys(this.map).forEach(function (key) {
        var item = _this.map[key];

        if (value.indexOf(item.value) >= 0) {
          group = item.group;
        }
      });
      this.group = group;
      Object.keys(this.map).forEach(function (key) {
        return _this.map[key].emitGroupChange();
      });
      return extra;
    }
  }, {
    key: "onItemChange",
    value: function onItemChange(item, checked) {
      if (item.free) {
        this.onChange([]);
        this.group = Group.GROUP_FREE;
        return;
      }

      var value = this.value.slice();
      var index = this.value.indexOf(item.value);

      if (index >= 0) {
        if (!checked) {
          value.splice(index, 1);
          this.onChange(value);
        }

        return;
      }

      if (!checked) {
        return;
      }

      if (value.length === 0 || item.group !== this.group) {
        this.onChange([item.value]);
        return;
      }

      var currentValue = typeof item.onSelect === 'function' ? item.onSelect(item.value, value) : value.concat(item.value);
      this.onChange(currentValue);
    }
  }, {
    key: "isItemChecked",
    value: function isItemChecked(item) {
      return item.free ? this.value.length === 0 : this.value.indexOf(item.value) >= 0;
    }
  }, {
    key: "register",
    value: function register(item) {
      if (this.map[item.id]) {
        console.error("duplicated group item: ".concat(item.value));
      }

      if (this.value.indexOf(item.value) >= 0) {
        this.group = item.group;
      }

      this.map[item.id] = item;
    }
  }, {
    key: "unregister",
    value: function unregister(item) {
      if (this.disposed) {
        return;
      }

      if (!this.map[item.id]) {
        console.error("item ".concat(item.value, " is not registered in this group"));
      }

      delete this.map[item.id];
      var value = this.value.slice();
      var index = value.indexOf(item.value);

      if (index >= 0) {
        value.splice(index, 1);
        this.onChange(value);
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.disposed = true;
      Object.values(this.map).forEach(function (item) {
        return item.dispose();
      });
      this.map = {};
    }
  }]);

  return Group;
}();
Group.GROUP_FREE = guid();